export const CLOUDINARY_CONFIG = {
  cloudName: 'dhxriuzu5',
  uploadPreset: 'hypnolab.ai',
  apiUrl: 'https://api.cloudinary.com/v1_1'
};